import OnboardingPractice from './OnboardingPractice'

export default OnboardingPractice
// eslint-disable-next-line import/export
export * from './OnboardingPractice'
